export var ClientIncomingMessageTypes;
(function (ClientIncomingMessageTypes) {
    ClientIncomingMessageTypes["OpenQuestion"] = "AI_FEEDBACK.OPEN_QUESTION";
    ClientIncomingMessageTypes["BeforeShowIframe"] = "AI_FEEDBACK.BEFORE_SHOW_IFRAME";
    ClientIncomingMessageTypes["ConsentPolicyChanged"] = "AI_FEEDBACK.CONSENT_POLICY_CHANGED";
})(ClientIncomingMessageTypes || (ClientIncomingMessageTypes = {}));
export var ClientOutgoingMessageTypes;
(function (ClientOutgoingMessageTypes) {
    ClientOutgoingMessageTypes["Ready"] = "AI_FEEDBACK.READY";
    ClientOutgoingMessageTypes["CloseFrame"] = "AI_FEEDBACK.CLOSE_FRAME";
    ClientOutgoingMessageTypes["LayoutIsReady"] = "AI_FEEDBACK.LAYOUT_IS_READY";
    ClientOutgoingMessageTypes["LayoutMountError"] = "AI_FEEDBACK.LAYOUT_MOUNT_ERROR";
})(ClientOutgoingMessageTypes || (ClientOutgoingMessageTypes = {}));
export var CloseReason;
(function (CloseReason) {
    CloseReason["FinishedFlow"] = "finished-flow";
    CloseReason["Canceled"] = "canceled";
    CloseReason["CanceledDueToError"] = "canceled-due-to-error";
})(CloseReason || (CloseReason = {}));
//# sourceMappingURL=messages.constants.js.map